// ActiveModuleTracker.js
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const moduleRoutes = {
  '/kird': 'Account',
  '/atm1': 'Fee',
  '/dainandin': 'MDM',
  '/GunaNeendani': 'Result',
  '/progresssheet': 'Result',
  '/subjectwise': 'Result',
  '/collectout': 'Result',
  '/gradewise': 'Result',
  '/dailyregister': 'Result',
  '/boardresult': 'Result',
  '/Icse': 'Result',
  '/promote': 'Result',

  '/IcseMarkRegisteration': 'Result',
  '/IcseResult': 'Result',
  '/IcseGradeWise': 'Result',
  '/IcseSubjectWise': 'Result',
  '/PrelimsResult': 'Result',
  '/PrelimsMarkEntry': 'Result',
  '/markenterhsc': 'Result',
  '/markenterssc': 'Result',
  '/resulthsc': 'Result',
  '/resultssc': 'Result',
  '/allmarkspath': 'Result',
  '/prgReportwtd': 'Result',
  '/prgReportwd': 'Result',

  '/preprimary': 'Result',
  '/cbsesubjectcwise': 'Result',
  '/cbsemarkentery': 'Result',
  '/cbseresult': 'Result',
  '/cbsehsresult': 'Result',

'AddTeacher': 'Payroll',

};

// ActiveModuleTracker.js
const ActiveModuleTracker = () => {
  const location = useLocation();
  const [currentModule, setCurrentModule] = useState(null);

  useEffect(() => {
    const matchedModule = Object.entries(moduleRoutes).find(([route]) =>
      location.pathname.startsWith(route)
    )?.[1];

    // Only update if module actually changed
    if (matchedModule !== currentModule) {
      if (currentModule) {
        window.dispatchEvent(new CustomEvent('moduleInactive', { detail: currentModule }));
      }
      if (matchedModule) {
        window.dispatchEvent(new CustomEvent('moduleActive', { detail: matchedModule }));
      }
      setCurrentModule(matchedModule);
    }

    return () => {
      if (currentModule) {
        window.dispatchEvent(new CustomEvent('moduleInactive', { detail: currentModule }));
      }
    };
  }, [location.pathname]);

  return null;
};

export default ActiveModuleTracker;